import React from 'react';
export function StickyHeader() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2" data-id="element-220">
        <div className="flex items-center justify-between gap-4" data-id="element-221">
          {/* Trust Badge - Left */}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9J6HdvUU8CEaFpZWXgDDTe/TRUSTED_BADGE.png" alt="Trusted by 1000+ Verified Customers - Trustpilot 5 Stars" className="h-8 sm:h-10 w-auto object-contain" data-id="element-222" />

          {/* Signature - Right */}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ffEqoc8aS1PC8Coiz1CKY3/gb_signature.png" alt="Gabriel Beltran Signature" className="h-8 sm:h-10 w-auto object-contain opacity-90" data-id="element-223" />
        </div>
      </div>
    </div>;
}